<template>
  <div class="wrap-helper-show g-flex-column-sb">
    <div class="back-btn"><el-button size="medium"  @click="$router.back(-1)">返回</el-button></div>
    <div :style="{ height:bannerHeight+'px', background: `url(${imgPath}${topBanner}) no-repeat`}" class="banner" >
      <template v-if="!btnGo">
        <div class="shop g-flex-c" v-if="btnType === 3" @click.stop="handleSign">立即报名</div>
        <div class="shop g-flex-c" v-else-if="btnType === 1" @click.stop="handleFinLuck">活动已结束</div>
        <div class="shop g-flex-c" v-else @click.stop="handleCheck">查看已报名</div>
        <div class="shopOil g-flex-c"><img src="https://web.nlktj.com/ty/merchant/white-fire.png" alt="">{{count || 0}}座油站累计参加</div>
      </template>
    </div>
    <div class="content">
      <div class="c_left">
        <div class="c_title">活动说明：</div>
        <div class="c_tip">活动时间内，<span style="font-weight: 600;">拉新用户数达标后 </span>即可领取免费大奖</div>
        <div class="c_list">
          <span>满足以下条件即为新用户：</span>
          <span v-for="(item, index) in conditions" :key="index">{{item}}</span>
        </div>
      </div>
      <div class="c_right">
        <div class="c_title">达标奖励：</div>
        <div class="c_tip">活动结束后达成以下拉新条件，<span style="font-weight: 600;">达标范围内 </span>可选择任意一项奖品，给您邮寄到手</div>
        <div class="c_list_box" v-if="drawRewards && drawRewards.length > 0">
          <div class="rewars_wrap" v-for="(item, index) in drawRewards" :key="index">
            <div class="reward_tip">{{index+1}}.拉新{{item.personNum}}人奖励{{item.rewardGift && item.rewardGift.length}}选1（价值{{item.rewardMoney}}元）：</div>
            <div class="reward_list"><span v-for="(itemChil, indexChil) in item.rewardGift" :key="indexChil">{{itemChil}}x1、</span></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="btnGo" class="next">
      <el-button class="cancal" @click="$router.push({ path: '/promotion/centerShow' })">取消</el-button>
      <el-button class="step" @click="$router.push({ path: '/promotion/treasureSign' })">下一步</el-button>
    </div>
  </div>
</template>
<script>
import { getEffectiveLuckDrawByGasId, getLuckDrawApplicantsCount, getActivityStatus } from '@/api/marketPromotion'
// import treasureList from '../components/treasureList'
import mixins from './mixin'
export default {
  // components: { treasureList },
  mixins: [mixins],
  data() { 
    return {
      btnGo: '', // 按钮跳转到这个页面
      count: '', // 参与商家数
      btnType: 3, // 按钮限时逻辑
      bannerHeight: 400,
      page:'care',
      imgPath: 'https://web.nlktj.com/ty/merchant/active/',
      topBanner: 'treasureBanner.png',
      drawRewards: [],
      conditions: []
    } 
  },
  mounted () {
    this.$track.pageViewEvent('3', 1632832578)

    const { btnGo } = this.$route.query
    this.btnGo = btnGo
    this.getLuckDrawApplicantsCountApi()
    this.getEffectiveLuckDrawByGasIdApi()
    this.getActivityStatusApi()
  },
  methods: {
    // 报名跳转
    async handleSign () {
      this.$track.clickEvent('立即报名', 1632832579, { tysj_trade_type: 3 })
      this.$router.push({ path: '/promotion/treasureSign' })
    },
    handleCheck () {
      this.$track.clickEvent('查看已报名', 1632832579, { tysj_trade_type: 3 })
      this.$router.push({ path: '/promotionAudit/myPromotion',  query: { id: 11 } })
    },
    setSize () {
      // 通过浏览器宽度(图片宽度)计算高度
      if(this.screenWidth < 1080) return
      this.bannerHeight = 400 / 1920 * this.screenWidth;
    },
    // 抽奖宝活动已结束
    handleFinLuck () {
      this.$message.info('该活动目前已结束，请下期及时报名参加')
    },
    // 抽奖宝油站数量
    async getLuckDrawApplicantsCountApi () {
      try {
        const { code, result } = await getLuckDrawApplicantsCount()
        if(code !== 200) return
        this.count = result
       } catch (error) {
        console.log(error)
      }
    },
    // 抽奖宝按钮展示逻辑
    async getActivityStatusApi () {
      try {
        const { code, result } = await getActivityStatus()
        if(code !== 200) return
        this.btnType = result
       } catch (error) {
        console.log(error)
      }
    },
    // 详情数据
    async getEffectiveLuckDrawByGasIdApi () {
      try {
        const { code, result } = await getEffectiveLuckDrawByGasId()
        if(code !== 200) return
        this.conditions = result.conditions
        this.drawRewards = result.drawRewards
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap-helper-show{
  width: 100%;
  padding: 10px 0;
  position: relative;
  margin-bottom: 80px;
  background: #F8F9FD;
}
.back-btn{
  width: 100%;
  margin: 0 0 10px 0;
  padding: 10px 0;
  background: #fff;
  margin-top: 10px;
  box-shadow: 0px 2px 2px 0px rgba(215, 215, 215, 0.4);
  border-radius: 1px;
  .el-button{
    width: 120px;
    height: 40px;
  }
}
.banner{
  width: 100%;
  border-radius: 5px;
  position: relative;
  background-size: 100%!important;
  margin-bottom: 10px;
  .shop{
    position: absolute;
    width: 176px;
    top: 64%;
    left: 10%;
    height: 46px;
    background: #15247C;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }
  .shopOil{
    position: absolute;
    top: 86%;
    left: 10%;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    >img{
      display: block;
      width: 12px;
      height: 16px;
      margin-right: 10px;
    }
  }
}
.content{
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  .c_left{
    width: 49.4%;
    height: 370px;
    background: #fff;
    padding: 16px;
    .c_title{
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      margin-bottom: 16px;
    }
    .c_tip{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 22px;
      margin-bottom: 8px;
    }
    .c_list{
      padding: 16px;
      // margin: 10px 16px;
      background: #F9FAFC;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      >span{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      >span:nth-child(1){
        margin-bottom: 10px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
      }
    }
  }
  .c_right{
    width: 49.4%;
    height: 370px;
    background: #fff;
    padding: 16px;
    box-sizing: border-box;
    .c_title{
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      margin-bottom: 16px;
    }
    .c_tip{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 22px;
      margin-bottom: 8px;
    }
    .c_list_box{
      padding: 16px;
      // margin: 10px 16px;
      background: #F9FAFC;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      max-height: 250px;
      overflow-y: scroll;
      line-height: 18px;
      .rewars_wrap{
        margin-bottom: 10px;
        .reward_tip{
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #27272A;
        }
        .reward_list{
          padding: 10px 0;
          margin-top: 2px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #64646C;
        }
      }
      .rewars_wrap:last-child{
        margin-bottom: 0;
      }
    }
  }
}
.next{
  position: fixed;
  bottom: 0;
  width: 86%;
  height: 80px;
  background: #FFFFFF;
  box-shadow: 0px -2px 8px 0px #F4F7FC;
  display: flex;
  justify-content: center;
  align-items: center;
  .cancal{
    width: 120px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #CCCCCC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .step{
    width: 120px;
    height: 40px;
    background: #4B7EFE;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
}
</style>